<template>
  <narrow-container>
    <h1 class="headline-secondary text--center">
      {{ $i18n.t('AUTO_TOPUP.LANDING_PAGES.HEADER') }}
    </h1>
    <br>
    <p class="text--center">
      {{ $i18n.t('AUTO_TOPUP.LANDING_PAGES.INFO_TEXT.ACTIVATION.SUCCESS') }}
    </p>
    <br>
    <div class="block--centered">
      <router-link
        class="button button--blue button--centered"
        :to="{name:'manage'}"
      >
        {{ $i18n.t('COMMON.OK') }}
      </router-link>
    </div>
  </narrow-container>
</template>

<script>
    export default {
      name: "AutoTopupActivationMPayLandingSuccess",
      components: {},
      mounted: function () {
        let price = '';
        if(this.$store.state.lastTopupValue) {
          price = ' '+this.$store.state.lastTopupValue+' EUR';
        }
        this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'AutoTopup',label: 'Success'+price, value: this.$store.state.lastTopupValue, noninteraction: false });
        this.$store.commit("clearLastTopupValue");
      }

    }
</script>

<style scoped lang="scss">
  .button--centered {
    padding-right: 62px;
    padding-left: 62px;
  }
  .block--centered {
    text-align: center;
  }
</style>
